import { render, staticRenderFns } from "./LiveVideo.vue?vue&type=template&id=7ab142c0&scoped=true&"
import script from "./LiveVideo.vue?vue&type=script&lang=js&"
export * from "./LiveVideo.vue?vue&type=script&lang=js&"
import style0 from "./LiveVideo.vue?vue&type=style&index=0&id=7ab142c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab142c0",
  null
  
)

export default component.exports